
/* Define ATC handler first so it always exists, even if CartItems
   is not ready yet or CartDrawerItems fails to register. */
window.__cartRecAddToCart = function (btn) {
  if (!btn || btn.classList.contains('is-loading') || btn.disabled) return false;

  var variantId = btn.getAttribute('data-variant-id');
  var routes = window.routes || {};
  if (!variantId || !routes.cart_add_url) return false;

  btn.classList.add('is-loading');
  btn.disabled = true;

  var cartDrawer = document.querySelector('cart-drawer');
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
    formData.append(
      'sections',
      cartDrawer
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);
  }

  function resetBtn() {
    btn.classList.remove('is-loading');
    btn.disabled = false;
  }

  function refreshUi(response) {
    if (!cartDrawer) return response;

    cartDrawer.classList.remove('is-empty', 'cart-drawer--empty');

    /* Prefer a fresh section fetch — more reliable in Safari than
       trusting sections embedded in the cart/add response. */
    if (typeof cartDrawer.refreshDrawer === 'function') {
      return cartDrawer.refreshDrawer().then(function () {
        return response;
      });
    }

    if (response && response.sections && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(response);
    }

    return response;
  }

  fetch(routes.cart_add_url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (response) {
      if (response.status) {
        throw new Error(response.description || 'Add to cart failed');
      }
      return refreshUi(response);
    })
    .then(function (response) {
      if (!response) return;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-recommendation',
          productVariantId: variantId,
          cartData: response,
        });
      }
    })
    .catch(function () {
      resetBtn();
    })
    .then(function () {
      resetBtn();
    });

  return false;
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;
    let renderedDrawer = false;
    const sections = parsedState.sections || {};

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = sections[section.id];
      if (!sectionHtml) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (innerHtml === null) return;

      sectionElement.innerHTML = innerHtml;
      if (section.id === 'cart-drawer') renderedDrawer = true;
    });

    if (!renderedDrawer && sections['cart-drawer']) {
      const drawerHtml = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      this.updateDrawerFromParsed(drawerHtml);
    }

    this.rebindOverlay();
    if (typeof window.updateDeliveryNoteTime === 'function') {
      window.updateDeliveryNoteTime();
    }

    if (this.hasAttribute('auto-open')) {
      setTimeout(() => this.open());
    }
  }

  refreshDrawer() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const drawerHtml = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateDrawerFromParsed(drawerHtml);
        return fetch(`${routes.cart_url}?section_id=cart-icon-bubble`);
      })
      .then((response) => response.text())
      .then((iconText) => {
        const iconHtml = new DOMParser().parseFromString(iconText, 'text/html');
        this.updateCartIconFromParsed(iconHtml);
        this.rebindOverlay();
      });
  }

  updateDrawerFromParsed(html) {
    const sourceCartDrawer = html.querySelector('cart-drawer');
    if (sourceCartDrawer) {
      this.classList.toggle('is-empty', sourceCartDrawer.classList.contains('is-empty'));
      this.classList.toggle('cart-drawer--empty', sourceCartDrawer.classList.contains('cart-drawer--empty'));
    }

    const drawerInner = this.querySelector('.drawer__inner');
    const sourceInner = html.querySelector('#CartDrawer .drawer__inner');
    if (!drawerInner || !sourceInner) return;

    if (drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    drawerInner.innerHTML = sourceInner.innerHTML;
    if (typeof window.updateDeliveryNoteTime === 'function') {
      window.updateDeliveryNoteTime();
    }
  }

  updateCartIconFromParsed(html) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    const sourceSection = html.querySelector('.shopify-section');
    if (cartIcon && sourceSection) {
      cartIcon.innerHTML = sourceSection.innerHTML;
    }
  }

  rebindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

if (typeof CartItems !== 'undefined') {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define('cart-drawer-items', CartDrawerItems);
  }
}

/* Backup delegated listener for browsers that strip inline handlers */
if (!window.__cartRecBound) {
  window.__cartRecBound = true;
  document.addEventListener(
    'click',
    function (event) {
      var el = event.target;
      if (el && el.nodeType !== 1) el = el.parentElement;
      var btn = null;
      while (el && el !== document.documentElement) {
        if (el.classList && el.classList.contains('cart-rec__atc-btn')) {
          btn = el;
          break;
        }
        el = el.parentElement;
      }
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      window.__cartRecAddToCart(btn);
    },
    true
  );
}
